/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_BearbeiterInputs */

const de__field_bearbeiter = /** @type {(inputs: _Field_BearbeiterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiter:in`)
};

/**

* @param {_Field_BearbeiterInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_bearbeiter = /** @type {((inputs?: _Field_BearbeiterInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_BearbeiterInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_bearbeiter(inputs)
});